import { Typography } from '@mui/material'
import React from 'react'
import Link from '../navigation/Link'
import { textOperators, dateOperators } from '../../utils/constants/operators'
import { buildStatusColumn } from '../fields/StatusField'
import ListModule from '../module/ListModule'
import Intervention from '../modules/Interventions/Intervention'
import DocumentPreview from '../document/DocumentPreview'

const InterventionSubModule = ({ userRight, user, location, statusList }) => {
  const OBJECT_TYPE = 'interventions'
  const customerId = location?.state?.id ?? null

  const options = {
    tableStyle: { maxHeight: 350, padding: '1px' },
    paperStyle: {},
    accessRight: userRight,
    actions: { go: true },
    objectType: OBJECT_TYPE,
    objectFilter: () => ({ customer_id: customerId, company_id: user.company_id }),
    isFilter: true,
    isExpand: true,
    defaultSorted: 'intervention_number',
    expand: (row) => {
      return <DocumentPreview Component={Intervention} document={row} />
    },
    columns: [
      {
        name: 'intervention_number',
        label: 'N° Intervention',
        isFilter: true,
        operators: textOperators
      },
      {
        name: 'intervention_date',
        label: 'Date Intervention',
        isFilter: true,
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY',
        operators: dateOperators
      },
      {
        display: 'quote.quote_number',
        name: 'quote_number',
        label: 'Devis',
        isFilter: false,
        operators: textOperators,
        mapping: (id, rowid) => (
          <Typography component='span'>
            <Link to='/quotes/view' state={{ id: rowid.quote_id, history: '/interventions' }}>
              {id}
            </Link>
          </Typography>
        )
      },
      { name: 'summary', label: 'Titre' },
      buildStatusColumn(OBJECT_TYPE, statusList)
    ]
  }

  const toolbar = {
    isFilter: true,
    columns: options.columns,
    isSubMod: true,
    style: { marginTop: '5px', marginBottom: '5px' },
    objectType: OBJECT_TYPE,
    accessRight: userRight,
    actions: { addFor: true },
    getContext: () => ({ customer_id: customerId }),
    columnVisibility: true
  }

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(InterventionSubModule)
